<div [formGroup]="form" class="w-100 d-flex flex-column align-items-center mb-3">
  <div class="app-labels d-flex justify-content-between w-100 mb-1">
    <div class="app-label app-min-label">
      {{ labelLow }}
    </div>
    <div class="app-label app-max-label">
      {{ labelHigh }}
    </div>
  </div>
  <div [formGroupName]="controlName + '_Group'" class="d-flex w-100 justify-content-between">
    @for (value of scale; track value; let i = $index) {
      <div class="form-check d-flex">
        <input
          class="form-check-input"
          type="radio"
          [formControlName]="controlName"
          [value]="value"
          [name]="controlName"
          [id]="controlName.split('_')[0] + '_' + value.toString()"
          (change)="onChange(value)"
          />
        <label [for]="controlName.split('_')[0] + '_' + value.toString()" class="ms-1">
          {{ value }}
        </label>
      </div>
    }
  </div>
</div>
